export default __webpack_public_path__ + "static/media/BANNER1_mobile.0fbf1c27.jpg";